module.exports = "MessageFormat.locale.en_CA = function ( n ) {\n    if ( n === 1 ) {\n        return \"one\";\n    }\n    return \"other\";\n};"


/*****************
 ** WEBPACK FOOTER
 ** /home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts@3/catpack/web_loaders/script-loader/~/raw-loader!./js/lib/messageformat/locale/en_CA.js
 ** module id = 75
 ** module chunks = 0 1 2 3 4
 **/